import React, { memo, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Icon, Input } from '@material-ui/core'
import Select from '@material-ui/core/Select'
import clsx from 'clsx'

import { changeHeader } from 'app/store/importCSV'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import Options from './Options'

import useStyles from './styles'

const HeaderSelect = ({
  initialValue,
  isInvalid,
  label,
  changedHeaderkey,
  index,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [isSelectorOpen, setIsSelectorOpen] = useState(false)

  const handleChange = ({ value, label }) => {
    setIsSelectorOpen((prevState) => !prevState)
    if (changedHeaderkey !== value) {
      dispatch(
        changeHeader({
          newValue: value,
          oldValue: changedHeaderkey || initialValue,
          label,
          index,
        }),
      )
    }
  }

  const arrowIcon = (
    <Icon className={classes.selectIcon}>keyboard_arrow_down_icon</Icon>
  )

  return (
    <Select
      value={isInvalid ? ' ' : changedHeaderkey || initialValue}
      renderValue={() => (
        <PrimaryTooltip title={label} placement="top">
          <span>{label}</span>
        </PrimaryTooltip>
      )}
      fullWidth
      className={clsx(classes.headerSelect, {
        [classes.invalidHeader]: isInvalid,
      })}
      disabled
      IconComponent={() => null}
      input={<Input onClick={() => {}} />}
      // Uncomment this to enable header select
      // IconComponent={() => arrowIcon}
      // input={<Input onClick={() => setIsSelectorOpen(!isSelectorOpen)} />}
      MenuProps={{
        classes: { paper: classes.select },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      }}
      open={isSelectorOpen}
    >
      <Options handleChange={handleChange} />
    </Select>
  )
}

HeaderSelect.propTypes = {
  initialValue: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  changedHeaderkey: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
}

export default memo(HeaderSelect)
